import { MenuItem } from '#components/patterns/menus/menu/index.ts';
import { useWhatsNew } from '#global/context/whats-new/useWhatsNew.tsx';
import { UpdatesDot } from '../updates-dot/UpdatesDot.tsx';
import styles from './WhatsNewMenuItem.module.css';

/**
 * {@link WhatsNewMenuItem} is the account-menu entry. The dot also rides on the menu's own button
 * (see {@link UserMenu}), because a marker inside a closed dropdown announces nothing.
 *
 * Named for its original "What's new" label; the UI says Notifications.
 */
export function WhatsNewMenuItem() {
  const { hasUnread, open } = useWhatsNew();

  return (
    <MenuItem onClick={open} className={styles.WhatsNewMenuItem}>
      <span>Notifications</span>
      {hasUnread ?
        <>
          <UpdatesDot />
          {/* The dot is decorative, so the state it conveys has to reach assistive tech as text */}
          <span className="visually-hidden">(unread)</span>
        </>
      : null}
    </MenuItem>
  );
}
